<template>
  <div class='rightContent'>
    <v-search
      :formContent='formContent'
      :SearchForm='SearchForm'
      :inline='true'
      :optareBtn='optareBtn'
      @resetFn='resetFn'
      @confirmFn='getListFn'
      @searchFn='getListFn'
      @delCarrierFn='delCarrierFn'
    />
    <div class='componentPage'>
      <oprateTable :tableData='tableData' @choozeTableFn='choozeTableFn' @rowDel='rowDel' @detailFn='detailFn' />
      <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                  :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
    </div>
    <!-- 详细 -->
    <DetailDialog :isShow.sync='isShow' :title='title' :detailObj='detailObj' />
  </div>
</template>

<script>
import bus from '@/utils/bus.js'

import { shareParam } from '@/api/modules/public.js'
import { operateDelete, operateDetail, operateList } from '@/api/modules/oprate.js'

import mixinForm from '@/utils/formMixins.js'

import oprateTable from './Talbe.vue'
import DetailDialog from './DetailDialog.vue'

export default {
  mixins: [mixinForm],

  components: {
    oprateTable,
    DetailDialog
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'public.carrier',
          type: 'input',
          paramsName: 'carrierName',
          isChooze: true
        },

        {
          id: 3,
          text: $t('public.event'),
          type: 'select',
          paramsName: 'event',
          selectParam: [],
          isChooze: false
        },
        //  后面补充
        // {
        //     id: 4,
        //     text: $t('integration.behavior'),
        //     type: 'input',
        //     paramsName: 'behavior',
        //     isChooze: false,
        // },
        {
          id: 5,
          text: 'public.status',
          type: 'select',
          paramsName: 'status',
          selectParam: [],
          isChooze: false
        },
        {
          id: 2,
          text: 'public.time',
          type: 'datetimerange',
          paramsName: 'time',
          isChooze: false
        }
      ],
      SearchForm: {
        carrierName: '',
        time: '',
        event: '',
        behavior: '',
        status: ''
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: 'public.tbopt_delete',
          method: 'delCarrierFn'
        }
      ],
      getCarrierType: {},
      getCarrierStatus: [],
      choozeTableData: [],

      isShow: false,
      title: '',
      detailObj: {},
      eventArray: []
    }
  },
  created () {
    this.shareParamFn()
    this.getCarrierType = JSON.parse(sessionStorage.getItem('getCarrierType'))
  },
  mounted () {
    bus.$on('nodeClickFn', row => {
      this.treeClickSearchFn(row)
    })
  },
  methods: {
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.scope = null
        this.SearchForm.scene = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.scope = row.scopeId
        this.SearchForm.scene = null
      } else {
        this.SearchForm.scope = null
        this.SearchForm.scene = row.sceneId
      }
      this.getListFn()
    },
    shareParamFn () {
      const P1 = shareParam({
        code: 'carrier_operate_event',
        type: 0
      })
      const P2 = shareParam({
        code: 'carrier_operate_status',
        type: 0
      })

      Promise.all([P1, P2]).then(res => {
        this.eventArray = [{
          value: '',
          label: 'deviceEvent.all'
        }].concat(res[0].result.map(item => {
          return {
            value: item.code,
            label: 'deviceEvent.' + item.content
          }
        }))
        this.formContent.forEach(item => {
          if (item.paramsName === 'event') {
            item.selectParam = this.eventArray
          } else if (item.paramsName === 'status') {
            item.selectParam = res[1].result.map(item => {
              return {
                value: item.code,
                label: 'carrier.' + item.content
              }
            })
          }
        })
      })
    },
    resetFn () {
      (this.SearchForm = {
        carrierName: '',
        time: '',
        event: '',
        behavior: '',
        status: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      }),
      this.getListFn()
    },
    getListFn () {
      const query = { ...this.SearchForm }
      if (query.time && query.time.length > 0) {
        query.from = this.$dateParseTime(query.time[0])
        query.to = this.$dateParseTime(query.time[1])
      }
      delete query.time
      operateList(query, this.getCarrierType.id).then(({
        result,
        pageInfo
      }) => {
        this.tableData = result
        this.total = pageInfo.total
      })
    },
    choozeTableFn (row) {
      this.choozeTableData = row
    },
    /** 批量删除 */
    delCarrierFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.$confirm()
        .then(() => {
          const id = this.choozeTableData.map(item => item.id)
          operateDelete({ id: id.join(',') }, this.getCarrierType.id).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {
        })
    },
    /** 单条删除 */
    rowDel (row) {
      this.$confirm()
        .then(() => {
          const id = this.choozeTableData.map(item => item.id)
          operateDelete({ id: row.id }, this.getCarrierType.id).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {
        })
    },
    /** 详情 */
    detailFn (row) {
      this.isShow = true
      this.title = `${row.carrierName}-${this.$timetransition(row.recordTime)}`+$t('syslog.operation_detail')
      operateDetail(row.id, this.getCarrierType.id).then(({ result }) => {
        this.detailObj = result
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
